import React from 'react'


export default function Pointer({direction, task, bgColor}) {


    Pointer.defaultProps = {
        direction: 'up'
    }

    // !direction && console.log("Pointer needs direction prop of up, down, left, or right")


  return (
      <>
      {task ? (
          <div
              onClick={() => task()}
              className={`w-10 h-10 flex bg-${bgColor} cursor-pointer rounded-lg text-white text-xl items-center justify-center font-normal hover:opacity-60 transition-opacity duration-300`}>
              <i className={`ri-arrow-${direction}-s-line `}></i>
          </div>

      ) : ( <div className={`w-10 h-10 flex bg-${bgColor} rounded-lg text-white text-xl  cursor-pointer items-center justify-center font-normal`}>

            <i className={`ri-arrow-${direction}-s-line `}></i>

        </div>

      )}

    </>
  )
}
